import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { FormattedMessage } from 'react-intl';
import { Gr8piFormattedDate } from '../../../components/Gr8piFormattedDateTime';

const GpiContactAgreement = ({ updateAgreement, agreedToBeContactedByGpi, gpiContactAgreementUpdatedOn }) => {
  return (
    <>
      <div>
        <Checkbox
          id="agreedToBeContactedByGpi"
          value={agreedToBeContactedByGpi}
          onChange={(event) => updateAgreement(event)}
          checked={!!agreedToBeContactedByGpi}
        />
        <span> </span>
        <label htmlFor="updateGpiAgreement" className="p-checkbox-label">
          <FormattedMessage
            id="user.communication-settings.gpi-contact-agreement"
            defaultMessage="Information from GPI, including newsletters, marketing, etc."
            tagName="strong"
          />
        </label>
      </div>
      <br />
      <div>
        <FormattedMessage id="user.communication-settings.updatedOn" defaultMessage="Updated on: " tagName="strong" />
        <span>{gpiContactAgreementUpdatedOn && <Gr8piFormattedDate dateValue={gpiContactAgreementUpdatedOn} />}</span>
      </div>
    </>
  );
};

export default GpiContactAgreement;
